import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import CashFormatter from '../../Common/cashFormatter';


class CityReportTable extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentDidMount() {
    if (this.props.rows) {
      const { rows } = this.props;
      this.setState({ rows });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      const { rows } = nextProps;
      this.setState({ rows });
    }
  }

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = (i) => JSON.parse(JSON.stringify(this.getRows()[i]))

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({
      rows: this.getRows(),
      sortColumn,
      sortDirection,
     });
  }

  render() {
    const columns = [
      {
        key: 'city',
        name: <Translate value="city" />,
        resizable: true,
        filterable: true,
        width: 200,
      },
      {
        key: 'sales',
        name: <Translate value="sales" />,
        resizable: true,
        filterable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'purchase',
        name: <Translate value="purchase" />,
        resizable: true,
        filterable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ar',
        name: <Translate value="total_ar" />,
        resizable: true,
        filterable: true,
        width: 100,
        formatter: CashFormatter,
      },
      {
        key: 'ap',
        name: <Translate value="total_ap" />,
        resizable: true,
        filterable: true,
        width: 100,
        formatter: CashFormatter,
      },
    ];

    const { minHeight } = this.props;

    return (
      <div id="city-report-table" id="CityReportTable-dataGrid1">
        <ReactDataGrid
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          minHeight={minHeight || 500}
          rowGetter={this.rowGetter}
          rowsCount={this.getSize()}
        />
      </div>
    );
  }
}

export default CityReportTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/CityReport/cityReportTable.jsx